import { DemandeValidationPjTypeEnum } from '@graphql/generated';
import { DemandeValidationPjType } from '@lib/models/demande-validation-pj/types/demande-validation-pj-type.type';

export class DemandeValidationPjTypeMapper {
  public static fromGraphQl(
    documentType?: DemandeValidationPjTypeEnum | null
  ): DemandeValidationPjType {
    const mapping: Record<DemandeValidationPjTypeEnum, DemandeValidationPjType> = {
      AUTRE: 'autre',
      COMMUN: 'commun',
    };
    return documentType ? mapping[documentType] : 'autre';
  }

  public static toGraphQl = (
    documentType: DemandeValidationPjType
  ): DemandeValidationPjTypeEnum => {
    const mapping: Record<DemandeValidationPjType, DemandeValidationPjTypeEnum> = {
      autre: DemandeValidationPjTypeEnum.Autre,
      commun: DemandeValidationPjTypeEnum.Commun,
    };
    return mapping[documentType];
  };
}
